import { render, staticRenderFns } from "./RawMaterial.vue?vue&type=template&id=3974a210&scoped=true"
import script from "./RawMaterial.vue?vue&type=script&lang=js"
export * from "./RawMaterial.vue?vue&type=script&lang=js"
import style0 from "./RawMaterial.vue?vue&type=style&index=0&id=3974a210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3974a210",
  null
  
)

export default component.exports